import React from 'react';
import BasemapDlgItem from './BasemapDialogueItem.js';

const BasemapDialogue = ({ basemaps, activeBasemapId }) => (
  <div>
    {
      basemaps.map((basemap) =>
        <BasemapDlgItem
          checked={activeBasemapId[0] === basemap.id}
          paramType={'basemap'}
          paramValue={basemap.id}
          label={basemap.label || basemap.title}
          description={basemap.description}
          key={basemap.id}
          inputType={'image'}
          imgSrc={basemap.imgSrc}
        />
      )
    }
  </div>

);

export default BasemapDialogue;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ShortcutMenu/BasemapDialogue.js
 **/